import ProBox from "./ProBox";
import React from "react";
import { projects } from "../../classes/models/ProjectModel";

function Projects() {
  return (
    <>
      <section id="projects" className="project">
        <div className="container">
          <div className="project-content">
            <p>portfolio</p>
            <h3>Some of my work</h3>
            <div className="projects-grid">
              {projects.map((model) => ProBox({ model }))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Projects;
